import { createAsyncThunk } from "@reduxjs/toolkit";
import { getUserPermissions } from "services/authAPI";

export const fetchUserPermissions = createAsyncThunk(
  '/backoffice/acteurs/permissions-list',
  async (id: string) => {
    const response = await getUserPermissions(id);
    return response;
  }
)

